module.exports = __webpack_public_path__ + "static/media/job_category_18.6672173e.png";